import React, { Component } from "react";
import ReportButtonGroup from "./reportButtonGroup";
import "../../styles/reports/reports.scss";
import { Table, Button } from "react-bootstrap";
import HighlightedDetailTab from "./highlightedDetailTab";
import AssetInforWarning from "./assetInforWarning";
import Calendar from "react-calendar/dist/umd/Calendar";
import GridLoader from "react-spinners/GridLoader";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import DropDownSearch from "./dropDownSearch";
import moment from "moment";
import { setLoadingPage, setErrorMessage, setHeaderVisible, setCustomerName } from "../../reducers/actions";
import { connect } from "react-redux";
import queryString from "query-string";

class AnimateTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetLoader: false,
      assetPlaceholder: "Select Asset",
      dataPlaceholder: moment().format("dddd Do MMMM, YYYY"),
      assetShow: false,
      groupTabHighlight: true,
      assetTabHighlight: false,
      groupTabHeading: true,
      assetTabHeading: true,
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      date: new Date(),
      calendarShow: false,
      groupList: [],
      assetList: [],
      assetId: "",
      checked: false,
      isLoading: false
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async componentDidMount() {
    const values = queryString.parse(window.location.search);
     if (values.assetId) {
         if (values.assetDate !== undefined && values.assetDate !== "null") {
             await this.setState({
                 dataPlaceholder: moment(values.assetDate).format(
                     "dddd Do MMMM, YYYY"
                 ),
                 selectedDate: values.assetDate,
             });
         }
         await this.setState({
             assetPlaceholder: values.assetName,
             assetId: values.assetId,
         });
     }

    let groupUrl = `${apiHost}/api/Notification/AllGroupForNotification`;
    this.getGroups(groupUrl);
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if (this.props.assetPlaceHolder != prevProps.assetPlaceHolder) {
      if (this.props.assetPlaceHolder) {
        this.setState({
          assetPlaceholder: this.props.assetPlaceHolder,
          assetSelect: true,
        });
      }
    }
    if (this.props.dateplaceholder != prevProps.dateplaceholder) {
      if (this.props.dateplaceholder) {
        console.log("datre===", this.props.dateplaceholder);
        this.setState({
          dataPlaceholder: this.props.dateplaceholder,
          dateSelect: true,
        });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  }

  getGroups = async (url) => {
    // this.props.setLoadingPageAction(true);
    try {
      const groupList = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ groupList: groupList.data });
      console.log("groupList ", groupList.data);
      //this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  postAssets = async (url) => {
    // this.props.setLoadingPageAction(true);

    try {
      const assetList = await axios.get(
        url,

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (assetList.status === 200) {
        this.setState({ isLoading: false, assetList: assetList.data.paggedlist, assetLoader: false });
      }
      else {
        this.setState({ isLoading: true });
      }
      console.log("Asset List", assetList.data.paggedlist);
      // this.setState({
      //   assetList: assetList.data.paggedlist,
      //   assetLoader: false,
      // });
      //this.handleShowResults(assetList);
      // this.completeAssetList = assetList.data.includedelements;
      // console.log("checked list of assets", this.checkedAssets);

      // this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleGroupSelection = (customer, name, groupId) => {
    this.setState({ assetLoader: true });
    this.setState({
      groupCustomerName: customer,
      groupGeneralName: name,
      assetCustomerName: "",
      assetGeneralName: "",
      assetTabHeading: true,
      groupTabHighlight: false,
      assetTabHighlight: true,
      groupTabHeading: false,
    });
    let url = `${apiHost}/api/Notification/AssetsByGroupId/${groupId}?IsReport=true`;
    this.postAssets(url);
  };
  handleAssetSelection = (asset, name, assetId) => {
    this.setState({
      assetCustomerName: asset,
      assetGeneralName: name,
      // groupTabHighlight:false,
      assetTabHighlight: false,
      assetTabHeading: false,
      assetId,
    });
    this.assetId = assetId;
  };
  toggleGroupTable = () => {
    let assetClosingBoolean = !this.state.groupTabHighlight;
    this.setState({
      groupTabHighlight: !this.state.groupTabHighlight,
    });

    if (assetClosingBoolean) {
      this.setState({
        assetTabHighlight: false,
      });
    }
  };
  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };
  toggleAssetTable = () => {
    let groupClosingBoolean = !this.state.assetTabHighlight;

    this.setState({
      assetTabHighlight: !this.state.assetTabHighlight,
    });
    if (groupClosingBoolean) {
      this.setState({
        groupTabHighlight: false,
      });
    }
  };
  truckFunction = () => {
    // alert("truck function clicked");
    this.setState({
      assetShow: !this.state.assetShow,
    });
  };
  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };
  onChangeDate = (date) => {
    console.log("daate", date);
    this.setState({
      date,
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
    });
    this.props.onDate(date);
    this.setState({
      calendarShow: false,
    });
  };

  handleOk = () => {
    this.setState({
      assetShow: false,
      assetPlaceholder: this.state.assetCustomerName,
    });

    this.props.onAssetId(this.assetId);
    //if (this.props.fromTrack || this.props.fromTemp) {
    if (typeof this.props.onAssetName === 'function') {
     this.props.onAssetName(this.state.assetCustomerName);
    }
  };

  handleFilter = (e) => {
    this.setState({ checked: !this.state.checked });
    this.props.onFilter(!this.state.checked);
  };

  render() {
    const GroupTable = (
      <div
        className={
          this.state.groupTabHighlight ? "tableHeight" : "tableSmoothHeight"
        }
      >
        <Table striped hover>
          <thead>
            <tr>
              <th>Customer</th>
              <th>Name</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {this.state.groupList.map((group) => {
              return (
                <tr
                  className="trRow"
                  title="click to select"
                  id="1"
                  onClick={(e) =>
                    this.handleGroupSelection(
                      group.customername,
                      group.groupName,
                      group.groupId
                    )
                  }
                >
                  <td>{group.customername}</td>
                  <td>{group.groupName}</td>
                  <td>{group.description}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );

    const AssetTable = (
      <div
        className={
          this.state.assetTabHighlight ? "tableHeight" : "tableSmoothHeight"
        }
      >
        {!this.state.isLoading && this.state.assetList.length > 0 ? (
          <Table striped hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {this.state.assetList.map((item, index) => {
                return (
                  <tr
                    className="trRow"
                    title="click to select"
                    id="1"
                    onClick={(e) =>
                      this.handleAssetSelection(
                        item.name,
                        item.customerName,
                        item.assetId
                      )
                    }
                  >
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>{item.statusId}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : this.state.isLoading && (
          <AssetInforWarning
            warningText={true}
            warningTextMsg=" No assets found"
          />
        )}
      </div>
    );

    const data = (
      <div
        className={
          this.state.assetShow
            ? "dropDownContainer smoothHeight"
            : "dropDownContainer"
        }
      >
        {this.state.groupList.length > 0 ? (
          <div className="dropDownContentMainContainer">
            <div className="dropDownHeading">
              {this.state.groupTabHeading ? (
                <h1>1. Select Group</h1>
              ) : (
                <HighlightedDetailTab
                  leftIcon="fa-th"
                  functionCall={this.toggleGroupTable}
                  click={this.state.groupTabHighlight}
                  customerName={this.state.groupCustomerName}
                  generalName={this.state.groupGeneralName}
                  count="114"
                />
              )}
            </div>
            <div className="dropDownContent">
              {GroupTable}
              {/* {this.state.groupTabHighlight?
              :""
            } */}
            </div>
            <br />
            {this.state.groupId != "" ? (
              <div>
                <div className="dropDownHeading">
                  {this.state.assetTabHeading ? (
                    <h1>2. Select Asset</h1>
                  ) : (
                    <HighlightedDetailTab
                      leftIcon="fa-truck"
                      click={this.state.assetTabHighlight}
                      functionCall={this.toggleAssetTable}
                      customerName={this.state.assetCustomerName}
                      generalName={this.state.assetGeneralName}
                      count="34"
                    />
                  )}
                </div>
                {!this.state.assetLoader ? (
                  <div className="dropDownContent">{AssetTable}</div>
                ) : (
                  <center>
                    <br />
                    <GridLoader
                      size={7}
                      color={"#222222"}
                      loading={this.state.assetLoader}
                    />
                    <br />
                  </center>
                )}
              </div>
            ) : (
              ""
            )}

            <div className="dropDownFooter">
              <Button
                variant="outline-secondary"
                onClick={() => {
                  this.setState({ assetShow: false });
                }}
              >
                Cancel
              </Button>
              &nbsp;
              {this.state.assetCustomerName != "" &&
                this.state.groupGeneralName != "" ? (
                <Button onClick={() => this.handleOk()} variant="success">
                  OK
                </Button>
              ) : (
                <Button variant="success" disabled>
                  OK
                </Button>
              )}
            </div>
          </div>
        ) : (
          <center>
            <br />
            <GridLoader size={7} color={"#222222"} loading={true} />
            <br />
          </center>
        )}
      </div>
    );

    const calendarReport = this.state.calendarShow ? (
      <div
        ref={this.setWrapperRef}
        className="ParentCalender"
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            maxDate={new Date()}
            onChange={this.onChangeDate}
            value={this.state.date}
          />
        </div>
      </div>
    ) : (
      ""
    );

    return (
      <React.Fragment>
        <div className="headingContainer">
          <h2 className="mainHeading">
            {this.props.heading}
            <span> v2.0.4</span>
          </h2>
          <i
            className={
              this.props.headerHide
                ? `fa fa-window-restore`
                : `fa fa-window-maximize`
            }
            onClick={this.handleWindow}
          />
        </div>

        <hr />
        <div className="inputFormGroup">
          <div className="inputElement">
            {this.props.dropDown == "yes" ? (
              <DropDownSearch
                caption="Select Group"
                icon="fa-truck"
                values={this.props.values}
              />
            ) : (
              <ReportButtonGroup
                function={this.truckFunction}
                dropDown={data}
                placeholder={this.state.assetPlaceholder}
                icon="fa-truck"
              />
            )}
          </div>
          {!this.props.fromTrack && (
            <div className="inputElement">
              <ReportButtonGroup
                function={this.calendarFunction}
                dropDown={calendarReport}
                placeholder={this.state.dataPlaceholder}
                icon="fa-calendar"
              />
            </div>
          )}
          <div
            className="inputElement"
            style={{ position: "relative", top: "2px" }}
          >
            {this.props > 0 && (
              <p>
                <input
                  type="checkbox"
                  onChange={(e) => this.handleFilter(e)}
                  defaultChecked={this.state.checked}
                ></input>{" "}
                Use Filtering{" "}
              </p>
            )}
            {this.props.assetSelect && this.props.dateSelect ? (
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => this.props.onCreateReport()}
              >
                {" "}
                Create Report{" "}
              </Button>
            ) : (
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => this.props.onCreateReport()}
                disabled={this.props.fromTemp ? false : true}
              >
                {" "}
                Create Report{" "}
              </Button>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
// const HighlightedDetailTab=(props)=>{
// return(

//     <div className="highlightedDetailBody" onClick={props.functionCall}>
//         <i className="fa fa-th"></i>
// <p>{props.customerName}<span>{props.generalName}</span>({props.count})</p>
// <i className="fa fa-caret-down"></i>
//     </div>
//     )
// }

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
  setCustomerName: setCustomerName

};

export default connect(mapStateToProps, mapDispatchToProps)(AnimateTable);
